// extracted by mini-css-extract-plugin
export var downArrow = "_f9-0";
export var infoTooltipIcon = "_f9-3";
export var label = "_f9-1";
export var optionCard = "_f9-4";
export var upArrow = "_f9-2";